var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.286,
    height: 16,
    viewBox: "0 0 18.286 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.143,32C4.093,32,0,35.325,0,39.429A6.593,6.593,0,0,0,2.036,44.1,9.086,9.086,0,0,1,.079,47.518a.284.284,0,0,0-.054.311A.28.28,0,0,0,.286,48a8.168,8.168,0,0,0,5.021-1.836,10.892,10.892,0,0,0,3.836.693c5.05,0,9.143-3.325,9.143-7.429S14.193,32,9.143,32ZM4.571,40.571a1.143,1.143,0,1,1,1.143-1.143A1.142,1.142,0,0,1,4.571,40.571Zm4.571,0a1.143,1.143,0,1,1,1.143-1.143A1.142,1.142,0,0,1,9.143,40.571Zm4.571,0a1.143,1.143,0,1,1,1.143-1.143A1.142,1.142,0,0,1,13.714,40.571Z",
    transform: "translate(0 -32)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentDots);
export default __webpack_public_path__ + "static/media/comment-dots.6c6c0f76f84c1898a5f4018813668c6d.svg";
export { ForwardRef as ReactComponent };